<template>
  <div
    v-maska="mask"
    class="input-text-field-renderer"
    :class="{
      'input-text-field-renderer--disabled': campo.desabilitado
    }"
  >
    <PInput
      v-if="!isStatusDescription"
      :model-value="modelValue"
      :label="campo.label"
      :placeholder="campo.placeholder ?? campo.descricao ?? ''"
      type="text"
      class="input-text-field-renderer__control"
      :error="error"
      :show-error="Boolean(error)"
      :required="campo.obrigatorio"
      :maxlength="campo.tamanho ?? undefined"
      :disabled="campo.desabilitado || isPartiallyMaskedCpf"
      :clearable="!campo.desabilitado && !isPartiallyMaskedCpf"
      @update:model-value="(v: string) => emit('update:modelValue', v)"
    />
    <PInputTextarea
      v-else
      :model-value="modelValue"
      :label="campo.label"
      :placeholder="campo.placeholder ?? campo.descricao ?? ''"
      :rows="3"
      class="input-text-field-renderer__control"
      :error="error"
      :show-error="Boolean(error)"
      :required="campo.obrigatorio"
      :disabled="campo.desabilitado"
      @update:model-value="(v: string) => emit('update:modelValue', v)"
    />
  </div>
</template>

<script setup lang="ts">
import { PInput, PInputTextarea } from "@f360-dev/f360-prisma";
import { computed } from "vue";
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";
import { EStatusDescriptionField } from "../../@types/IntegracaoCampoEnum";
import useNamedMask from "../../composables/dynamicForm/handlers/useNamedMask/useNamedMask";

const props = defineProps<{
  campo: TIntegracaoCampoModel;
  modelValue: string;
  error?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const { vMaska, resolveMask } = useNamedMask();

const isPartiallyMaskedCpf = computed(() => {
  const value = String(props.modelValue ?? "");
  return (
    props.campo.mascara === "cpf" &&
    /^\*{3}\.\*{3}\.\d{3}-\d{2}$/.test(value)
  );
});

const isStatusDescription = computed(() => {
  return (
    props.campo.nomeObjetoNoLegado === EStatusDescriptionField.LegacyProperty ||
    props.campo.nomeCampo === EStatusDescriptionField.StoneFieldId
  );
});

const mask = computed(() => {
  return isPartiallyMaskedCpf.value
    ? undefined
    : resolveMask(props.campo.mascara);
});
</script>

<style scoped>
.input-text-field-renderer {
  width: 100%;
}

.input-text-field-renderer :deep(.input-text-field-renderer__control) {
  width: 100%;
}

.input-text-field-renderer--disabled {
  /* TODO[FINC-1673]: rever no Prisma o contraste do texto em campos desabilitados. */
  --prisma-disabled-text-color: var(--prisma-text-color-regular, #606266);
}

.input-text-field-renderer :deep(.el-textarea__inner) {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  resize: vertical;
}
</style>
